/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallReceived = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m18.293 4.293 1.414 1.414L7.414 18H15v2H4V9h2v7.585z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCallReceived as CallReceived };
